<template>
    
    <div class="w-full h-auto bg-gray-200 p-6 rounded-cs-md grid gap-6" >

        <div class="grid grid-cols-6 items-center" >

            <p class="col-span-2" >Location</p>

            <radio class="col-span-4" :options="locationOptions" v-model="locationOption" />

        </div>

        <div v-if="locationOption.id === 1" >

            <c-input type="text" label="Address" v-model="address" @keyup="block = false" />

            <transition-group 
            
            tag="div"
            name="slide"
            class="bg-white mt-1 rounded-cs-md rounded-t-none" 
            
            >

                <div class="h-12
                            px-4
                            flex
                            items-center
                            border-b
                            border-solid
                            border-gray-200
                            last:border-0
                            cursor-pointer
                            hover:bg-gray-100"
                
                :key="index" 
                
                v-for="(item, index) in result"

                @click="setAddress( item.label )" 
                
                >

                    <p class="text-sm"  v-html="item.label.split(',').reverse().join(', ')" />

                </div>

            </transition-group>

        </div>

    </div>

</template>

<script>

    // key="Geocoding.ApiKey"
    // value="YXBwX2lkPXBQTnZSUEZuNW4zSFREY2h2S1Z2JmFwcF9jb2RlPVF5SkZRQTRneFNJeFBXMEF4anZ1SlE="

    // geocodingChange($event) {
    // if ($event.term.length > 2) {
    //   //show loading
    //   this.geocodingLoading = '-';
    //   let query = "https://autocomplete.geocoder.api.here.com/6.2/suggest.json?app_id=pPNvRPFn5n3HTDchvKVv&app_code=QyJFQA4gxSIxPW0AxjvuJQ&beginHighlight=%3Cstrong%3E&endHighlight=%3C/strong%3E&country=USA,CAN,GUM,PRI,MNP,VIR,NIC&query=" + $event.term;
    //   this.http.get(query).subscribe(res => {      
    //     let model = res.json();
    //     this.geocodingData = [];
    //     model.suggestions.forEach(element => {
    //       element.formatedLabel = this.toHTML(element.label.split(', ').reverse().join(', '));
    //     });
    //     this.geocodingData = model.suggestions;
    //     this.openGeocoding = '-';
    //     //hide loading
    //     this.geocodingLoading = '';
    //     //  model.suggestions
    //   });
    // } else {
    //   this.openGeocoding = '';
    // }

    import { ref, watch, reactive, onMounted } from 'vue'

    import { parser } from '../assets/scripts/parser'
    import { debounce } from '../assets/scripts/debounce'

    import radio from './radio'
    import cInput from './input'

    export default {
        
        name: 'Geolocation',

        components: { radio, cInput },

        setup(props, context) {

            const locationOptions = reactive([
                {
                    id: 1,
                    name: 'Geo Location'
                },
                {
                    id: 2,
                    name: 'Custom Address'
                }
            ])

            const locationOption = ref({})

            // Geocoding

            const block = ref(false) // Block API requests if address is selected

            const address = ref('')
            const result = ref([])

            const geoProperties = reactive({

                geocodeUrl: '',
                proxLatLng: '',
                autocompleteUrl: 'https://autocomplete.geocoder.api.here.com/6.2/suggest.json?app_id=pPNvRPFn5n3HTDchvKVv&app_code=QyJFQA4gxSIxPW0AxjvuJQ&beginHighlight=<strong>&endHighlight=</strong>',
                countryFilter: '&country=USA,CAN,GUM,PRI,MNP,VIR,NIC'

            })

            // Bias the autocomplete object to the user's geographical location,
            // as supplied by the browser's 'navigator.geolocation' object.

            const getLatLong = () => {

                if ( navigator.geolocation ) {

                    navigator.geolocation.getCurrentPosition((pos) => {

                        geoProperties.proxLatLng = `&prox=${pos.coords.latitude},${pos.coords.longitude}`

                    })

                }

            }

            onMounted(getLatLong)

            // Request address sugestions when user stop typing

            const requestAddress = debounce( async function() {

                if( !block.value ) {

                    const url = geoProperties.autocompleteUrl + geoProperties.countryFilter + geoProperties.proxLatLng + `&query=${address.value}`

                    const request = await fetch(url)
                    const response = await request.json()

                    result.value = response.suggestions

                }

            }, 500)

            // Remove HTML tags from the address and set address value

            const setAddress = value => {

                block.value = true
                result.value = []

                const div = document.createElement("div")
                div.innerHTML = value

                address.value = div.innerText.split(',').reverse().join(', ')

            }

            watch( address, requestAddress )

            return {
                block,
                result,
                address,
                setAddress,
                geoProperties,
                locationOption,
                locationOptions
            }

        }

    }

</script>

<style scoped>

    .slide-enter-active {

        transition: 0.3s;
    }

    .slide-leave-active {

        transition: 0.1s;
    }

    .slide-leave-to {

        opacity: 0;
    }

    .slide-enter-from {

        transform: translateY(2.5rem);
        opacity: 0;
    }

</style>